import React, { type ComponentType } from 'react';
import { cn } from '@/lib/utils';
import IconArrowDown from '@/assets/icons/icon-arrow-down.svg?react';
import clsx from 'clsx';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface DropdownFieldProps {
  className: string;
  classNameContent: string;
  text: string;
  size?: 'small' | 'large' | 'full' | 'extrasmall' | 'none';
  childrenMenu: React.ReactNode;
  childrenTrigger: React.ReactNode;
  icon: ComponentType<React.SVGProps<SVGSVGElement>> | null;
  onOpenChange?: (open: boolean) => void;
  open?: boolean;
}

export const DropdownField: React.FC<DropdownFieldProps> = ({
  className,
  classNameContent,
  text = 'Text',
  size = 'small',
  childrenMenu,
  icon: Icon,
  childrenTrigger,
  onOpenChange,
  open,
}) => {
  const handlerChange = (open: boolean) => {
    if (onOpenChange) {
      onOpenChange(open);
    }
  };
  return (
    <div className={cn('flex items-center justify-between gap-2', className)}>
      {text !== '' && <p className="text-button-sm font-medium text-neutral-500">{text}</p>}

      <DropdownMenu open={open} onOpenChange={handlerChange}>
        {!childrenTrigger && (
          <>
            <DropdownMenuTrigger
              className={clsx(
                'group flex w-full cursor-pointer items-center justify-between gap-2 rounded-lg bg-neutral-50 p-2 outline-none',
                {
                  'max-w-[96px]': size === 'extrasmall',
                  'max-w-[140px]': size === 'small',
                  'max-w-[160px]': size === 'large',
                  'max-w-[216px]': size === 'full',
                },
              )}
            >
              <div className="flex items-center gap-2">
                {Icon && (
                  <>
                    <Icon className={clsx('h-4 w-4 text-neutral-500', {})} />
                  </>
                )}
                <span className="text-button-sm text-neutral-900">Value</span>
              </div>
              <IconArrowDown className="h-4 min-h-4 w-4 min-w-4 text-neutral-500 transition-transform duration-200 group-aria-expanded:rotate-180" />
            </DropdownMenuTrigger>
          </>
        )}
        {childrenTrigger && <>{childrenTrigger}</>}
        <DropdownMenuContent
          align="start"
          className={clsx(
            'bg-neutral-0 rounded-md shadow-[0px-0px-8px-0px-rgba(0,0,0,0.15)] outline outline-offset-[-1px] outline-neutral-100',
            classNameContent,
            {
              'w-[96px]': size === 'extrasmall',
              'w-[140px]': size === 'small',
              'w-[160px]': size === 'large',
              'w-[216px]': size === 'full',
            },
          )}
        >
          {childrenMenu}
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
};
